export class QuestionItem {

    kind: string;
    captured: string;
    id: number;

}


// WEBPACK FOOTER //
// ./src/models/questionitem.ts